export default {
  title: 'Criador de Sites',
  welcome: 'Bem-vindo',
  description: 'Esta é a lista de sites feitos no Criador de Sites'
}
